import React, { useState, useEffect } from "react";
import clienteAxios from "../../axios";
import ModalConfirm from "../ModalConfirm";
import ModalAgregarPedido from './ModalAgregarPedido'; // Importamos el nuevo modal para agregar pedidos
import ArticulosPedido from './ArticulosPedido';  // Importamos el componente de artículos


const Pedidos = ({ restauranteId }) => {
    const [pedidos, setPedidos] = useState([]);
    const [busqueda, setBusqueda] = useState("");
    const [editandoPedido, setEditandoPedido] = useState(null);
    const [showConfirmModal, setShowConfirmModal] = useState(false);
    const [pedidoSeleccionado, setPedidoSeleccionado] = useState(null);
    const [nombreRestaurante, setNombreRestaurante] = useState(""); // Estado para almacenar el nombre del restaurante
    const [showAgregarPedidoModal, setShowAgregarPedidoModal] = useState(false);  // Estado para mostrar el modal


    // Función para obtener los datos del restaurante usando el restauranteId
    const obtenerRestaurante = async () => {
        try {
            const response = await clienteAxios.post("/api/sp", {
                sp: "tools",
                op: "Listar",
                modulo: "restaurantes"
            });

            const restaurante = response.data.data[0].find(item => item.id === restauranteId);
            if (restaurante) {
                setNombreRestaurante(restaurante.nombre); // Almacenar el nombre del restaurante
            }
        } catch (error) {
            console.log(error);
        }
    };

    // Función para obtener los pedidos
    const obtenerPedidos = async () => {
        try {
            const response = await clienteAxios.post("/api/sp", {
                sp: "tools",
                op: "Listar",
                modulo: "pedidos"
            });
            setPedidos(response.data.data[0].filter(item => item.restaurante_id === restauranteId));
        } catch (error) {
            console.log(error);
        }
    };

    useEffect(() => {        
        obtenerRestaurante(); // Llamamos la función para obtener los detalles del restaurante
        obtenerPedidos(); // Obtenemos los pedidos al cargar el componente
    }, [restauranteId]);

    // Función para manejar la barra de búsqueda
    const handleBusqueda = (e) => {
        setBusqueda(e.target.value.toLowerCase());
    };

    const pedidosFiltrados = pedidos.filter(item =>
        item.monto_total.toString().includes(busqueda)
    );

    // Función para editar pedido
    const editarPedido = (pedidoItem) => {
        setEditandoPedido(pedidoItem);
    };

    // Función para guardar pedido editado
    const guardarPedidoEditado = async () => {
        try {
            await clienteAxios.post("/api/sp", {
                sp: "tools",
                op: "Actualizar",
                modulo: "pedidos",
                id: editandoPedido.id,
                restaurante_id: editandoPedido.restaurante_id,
                monto_total: editandoPedido.monto_total
            });
            setEditandoPedido(null);
            obtenerPedidos(); // Actualizar lista
        } catch (error) {
            console.log(error);
        }
    };

    // Función para eliminar pedido
    const confirmarEliminarPedido = (pedidoItem) => {
        setPedidoSeleccionado(pedidoItem);
        setShowConfirmModal(true);
    };

    const eliminarPedido = async () => {
        try {
            await clienteAxios.post("/api/sp", {
                sp: "tools",
                op: "Eliminiar",
                modulo: "pedidos",
                id: pedidoSeleccionado.id
            });
            setShowConfirmModal(false);
            obtenerPedidos(); // Actualizar lista
        } catch (error) {
            console.log(error);
        }
    };

    // Función para abrir el modal de agregar pedido
    const handleAbrirAgregarPedidoModal = () => {
        setShowAgregarPedidoModal(true);
    };

    // Función para cerrar el modal de agregar pedido
    const handleCerrarAgregarPedidoModal = () => {
        setShowAgregarPedidoModal(false);
    };

    return (
        <div>
            {/* Mostrar pedidos si el botón ha sido presionado */}
            <div className="mt-4 border p-4 rounded-lg">
                <h3 className="text-lg font-semibold">Pedidos del Restaurante: {nombreRestaurante}</h3>

                {/* Barra de búsqueda */}
                <input
                    type="text"
                    placeholder="Buscar por monto total..."
                    value={busqueda}
                    onChange={handleBusqueda}
                    className="border rounded-lg p-2 mb-4 mt-2 w-1/2 min-w-[200px]"
                />

                {/* Botón para abrir el modal de agregar pedido */}
                <button
                    onClick={handleAbrirAgregarPedidoModal}
                    className="bg-blue-500 text-white px-4 py-2 rounded ml-2 hover:bg-blue-400 ml-6"
                >
                    Agregar Nuevo Pedido
                </button>

                <ul>
                    {pedidosFiltrados.map((item) => (
                        <li key={item.id} className="border-4 border-blue-400 rounded p-2 mb-2 mt-4">
                            {editandoPedido && editandoPedido.id === item.id ? (
                                <>
                                    <h3 className=" font-semibold mt-2">Monto Total del Pedido:</h3>
                                    <input
                                        type="text"
                                        value={editandoPedido.monto_total}
                                        onChange={(e) =>
                                            setEditandoPedido({ ...editandoPedido, monto_total: e.target.value })
                                        }
                                        className="border rounded-lg p-2 mr-2"
                                        maxLength={10}
                                    />
                                    <div className="flex mt-4 mb-2">
                                        <button
                                            onClick={guardarPedidoEditado}
                                            className="bg-green-500 text-white rounded px-2 py-1 mt-2 w-40"
                                        >
                                            Guardar
                                        </button>
                                        <button
                                            onClick={() => setEditandoPedido(null)}
                                            className="bg-gray-500 text-white rounded px-2 py-1 mt-2 ml-2 w-40"
                                        >
                                            Cancelar
                                        </button>
                                    </div>
                                </>
                            ) : (
                                <>
                                    <span><strong>Pedido ID:</strong> {item.id}</span><br />
                                    <span><strong>Restaurante ID:</strong> {item.restaurante_id}</span><br />
                                    <span><strong>Monto Total:</strong> {item.monto_total}</span><br />
                                    <button
                                        onClick={() => editarPedido(item)}
                                        className="bg-gray-500 text-white rounded px-2 py-1 mt-2 hover:bg-gray-400 " 
                                    >
                                        Editar
                                    </button>
                                    <button
                                        onClick={() => confirmarEliminarPedido(item)}
                                        className="bg-red-600 text-white rounded px-2 py-1 mt-2 ml-2 hover:bg-red-500"
                                    >
                                        Eliminar
                                    </button>

                                    {/* Renderizamos el componente ArticulosPedido para cada pedido */}
                                    <ArticulosPedido pedidoId={item.id} />
                                </>
                            )}
                        </li>
                    ))}
                </ul>
            </div>

            {/* Modal de confirmación */}
            <ModalConfirm
                show={showConfirmModal}
                message="¿Estás seguro de que quieres eliminar este pedido?"
                onConfirm={eliminarPedido}
                onCancel={() => setShowConfirmModal(false)}
            />

            {/* Modal para agregar nuevo pedido */}
            <ModalAgregarPedido
                show={showAgregarPedidoModal}
                onClose={handleCerrarAgregarPedidoModal}
                restauranteId={restauranteId}
                onPedidoAgregado={obtenerPedidos}  // Actualiza la lista de pedidos al agregar
            />
        </div>
    );
};

export default Pedidos;
